'use strict';
import { DashboardBase } from './DashboardBase';
import Render from './DashboardRender';
import { connect } from 'react-redux';

class Dashboard extends DashboardBase {
    componentDidUpdate() {
        const element = document.getElementById('scrollToTopContainer');
        if (element) {
            element.scroll(0, 0);
        }
    }
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default Dashboard = connect((state)=>{
    return {user:state.user || {}}
})(Dashboard);